﻿import { Component, OnInit } from '@angular/core';
import { RestService } from 'src/app/_services/rest.service';
import { ActivatedRoute } from '@angular/router';
import { UtilService } from 'src/app/_services/util.service';

@Component({ templateUrl: 'cargar.interhouse.component.html' })
export class CargarInterhouseComponent implements OnInit {

    data: any;

    categoriaDeporte: any;

    categoriaDeporteObject: any;

    anio: any;

    sexo: any;

    sexoObject: any;

    data2: any;

    editing = {};

    tmp = {};

    tabla: Array<any>;

    
    constructor(private restService: RestService, private route: ActivatedRoute, private utilService: UtilService) {
        this.route.queryParams.subscribe(params => {
            if (params['sexo']) {
                this.sexo = JSON.parse(params['sexo']);
                this.categoriaDeporte = JSON.parse(params['categoria']);
            }
            if (params['anio']) {
                this.anio = JSON.parse(params['anio']);
            } else {
                this.anio = this.currentYear();
            }
            this.loadAll();
        });
    }

    ngOnInit() {
    }

    loadAll() {
        this.restService.getAll('/rest-api/user/interhouses/cargar').subscribe(data => {
            this.data = data;
            this.searchAlumnos();
        }); 
    }


    searchAlumnos() {
        if (this.categoriaDeporte && this.sexo) {
            //this.loadRecord(this.sexo, this.categoriaDeporte);
            this.categoriaDeporteObject = undefined;
            this.sexoObject = undefined;
            this.restService.getAll('/rest-api/user/interhouses/partidos?sexo=' + this.sexo.toString() +
                '&categoriaDeporte=' + this.categoriaDeporte.toString() +
                '&anio=' + this.anio).subscribe((data:any) => {
                    this.data2 = data.partidos;
                    data.partidos.forEach((a,i) => this.editing[i]=false);
                    this.getTabla();
                });
        }
    }


    getTabla() {
        if (this.categoriaDeporte && this.sexo) {
            this.categoriaDeporteObject = undefined;
            this.sexoObject = undefined;
            this.restService.getAll('/rest-api/user/interhouses/tabla?sexo=' + this.sexo.toString() +
                '&categoriaDeporte=' + this.categoriaDeporte.toString() +
                '&anio=' + this.anio).subscribe((data:any) => {
                    this.tabla = data;
                });
        }
    }

    // getDatos(): any {
    //     return {
    //         'data': this.data2.partidos,
    //         'alumno': this.data2.alumnos,
    //         'puesto': this.data2.puesto,
    //         'paramAnio': this.anio, //this.currentYear(),
    //         'paramCategoriaDeporte': this.getCategoriaDeporte(),
    //         'paramSexo': this.getSexo()
    //     };
    // }

    getCategoriaDeporte(): any {
        //if (!this.categoriaDeporteObject) {
        this.data.categoriaDeporte.forEach(cat => {
            if (this.categoriaDeporte.toString() === cat.id.toString()) {
                this.categoriaDeporteObject = cat;
            }
        });
        //}
        return this.categoriaDeporteObject;
    }

    getSexo(): any {
        // if (!this.sexoObject) {
        this.data.sexo.forEach(cat => {
            if (this.sexo.toString() === cat.id.toString()) {
                this.sexoObject = cat;
            }
        });
        // }
        return this.sexoObject;
    }

    getSexoByID(id): any {
        let resp;
        this.data.sexo.forEach(cat => {
            if (id === cat.id) {
                resp = cat;
            }
        });
        return resp;
    }


    currentYear(): number {
        return (new Date()).getFullYear();
    }


    getGrado(categoria: any, sexo:any) : string {
        return this.utilService.getGrado(categoria, sexo);
    }

    editar(id: number, partido: any) {
        if (!this.editing[id]) {
            this.tmp[id] = {"local": partido.valorLocal,"visitante": partido.valorVisitante, "activo": partido.activo};
            this.editing[id] = true;
        }
    }

    cancelar(id: number) {
        this.editing[id] = false;
    }

    cambiar(id: number) {
        this.tmp[id].activo = !this.tmp[id].activo;
    }

    guardar(index: number) {
        const p = this.data2[index];
        p.valorLocal= this.tmp[index].local        
        p.valorVisitante= this.tmp[index].visitante
        p.activo = this.tmp[index].activo
        this.restService.post("/rest-api/user/partido", p)
            .subscribe(
                data => {
                    this.getTabla();
                    this.data2[index] = data;
                    this.editing[index] = false;                    
                });
    }

}
